export function showSpinner() {
  document.getElementById('loading-bg').style.display = 'block'
}

export function hideSpinner() {
  document.getElementById('loading-bg').style.display = 'none'
}
